import React, { createContext, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme as initialTheme } from '../../config/theme';

const ThemeContext = createContext({
    theme: initialTheme,
});

const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(initialTheme);

    return <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;
};
export { ThemeContext, ThemeProvider };
